import { VehicleStatus } from "static/js/app/models/__index";
import { Availability } from "static/js/app/models/__index";

export class GetMakesOptions {
    constructor(
        public vehicleStatus: VehicleStatus = "used",
        public vehicleType: string = "",
        public availability: Availability = "available"
        
    ) { }
}